import { render, staticRenderFns } from "./DuoProducoes.vue?vue&type=template&id=6b882c28&scoped=true"
import script from "./DuoProducoes.vue?vue&type=script&lang=js"
export * from "./DuoProducoes.vue?vue&type=script&lang=js"
import style0 from "./DuoProducoes.vue?vue&type=style&index=0&id=6b882c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b882c28",
  null
  
)

export default component.exports